export default {"src":"/_next/static/media/phone_64.83d9ed57.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};